import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  seoTitle,
  description,
  path = "",
  image = "https://aquinojapao.com/og-default.png",
  type = "website",
}) {
  const headlineForTitle = seoTitle || title;
  const fullTitle = headlineForTitle
    ? `${headlineForTitle} · Aqui no Japão`
    : "Aqui no Japão — Ferramentas honestas para brasileiros no Japão";
  const url = `https://aquinojapao.com${path}`;
  const desc =
    description ||
    "Calculadoras e guias práticos para brasileiros no Japão. Salário líquido, imposto, aposentadoria. Feito por quem vive aqui.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_BR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
